import { render, staticRenderFns } from "./ActualizacionEntrega.vue?vue&type=template&id=60c33726&"
import script from "./ActualizacionEntrega.vue?vue&type=script&lang=js&"
export * from "./ActualizacionEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports